import { http } from "@/utils/http";
export const loginOauth2 = (params) => {
  // 通过code和return_url换区token
  return http({
    url: `/1/login/oauth2`,
    headers: {
      "content-Type": "application/json",
    },
    method: "post",
    data: params,
  });
};
export const getUserInfo = () => {
  // 获取当前登录用户信息
  return http({
    url: `/1/users/me`,
    method: "get",
  });
};
export const logout = () => {
  // 登出
  return http({
    url: `/1/logout/`,
    method: "post",
  });
};

